import { useController, useFormContext } from 'react-hook-form'

import { RadioGroup } from '@/components/ui/radio'

import { businessTypeOptions } from '../../consts'
import type { QuestionnaireFormValues } from '../../types'
import { QuestionnaireFormButton } from '../components/button'
import { RadioButton } from '../components/radio-button'
import { QuestionnaireStep } from '../components/step'

interface Props {
  onClickNext: () => void
}

export const BusinessTypeStep = ({ onClickNext }: Props) => {
  const { control } = useFormContext<QuestionnaireFormValues>()
  const { field } = useController({
    control,
    name: 'businessType',
  })

  return (
    <QuestionnaireStep
      title="What’s your position?"
      description="Select your business role to customise your user experience."
      actions={
        <QuestionnaireFormButton
          disabled={!field.value}
          className="ml-auto w-[120px]"
          onClick={onClickNext}
        >
          Next
        </QuestionnaireFormButton>
      }
    >
      <RadioGroup
        value={field.value}
        onChange={field.onChange}
        className="space-y-5"
      >
        {businessTypeOptions.map(({ value, label, icon: Icon }) => (
          <RadioButton
            key={value}
            value={value}
            variant="full"
          >
            <Icon />
            {label}
          </RadioButton>
        ))}
      </RadioGroup>
    </QuestionnaireStep>
  )
}
